<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <!-- 使用 Element UI 的原生页签，但只显示一个固定的页签 -->
      <el-tabs v-model="activeTabName" type="card" style="width:100%;">
        <el-tab-pane name="billPaymentList">
          <template #label>
            <div class="custom-tab-label">
              <!-- 平铺按钮方式 -->
              <div class="flat-tabs-container">
                <!-- 非 UI 自定义模式 -->
                <template v-if="!uiCustomEnable">
                  <div
                    :class="['flat-tab-item', { active: applicationStatus === 0 }]"
                    @click.stop="switchTab(0)"
                  >
                    {{ $t('CargoMsg.Cargo_PaymentRequest') }}
                  </div>
                </template>

                <!-- UI 自定义模式 -->
                <template v-if="uiCustomEnable">
                  <div
                    v-if="$checkPermission(['tab_ACPayAuth_fbAll'])"
                    :class="['flat-tab-item', { active: applicationStatus === 5 }]"
                    @click.stop="switchTab(5)"
                  >
                    {{ $t('CargoMsg.Cargo_AllPaymentRequests') }}
                  </div>

                  <div
                    v-if="$checkPermission(['tab_ACPayAuth_fbWait'])"
                    :class="['flat-tab-item', { active: applicationStatus === 0 }]"
                    @click.stop="switchTab(0)"
                  >
                    {{ $t('Payment.notSubmitted') }}
                  </div>

                  <div
                    v-if="$checkPermission(['tab_ACPayAuth_fbApproval'])"
                    :class="['flat-tab-item', { active: applicationStatus === 1 }]"
                    @click.stop="switchTab(1)"
                  >
                    {{ $t('Payment.awaitBusinessApproval') }}
                  </div>

                  <div
                    v-if="billPaymentSetting.departmentApproval"
                    :class="['flat-tab-item', { active: applicationStatus === 6 }]"
                    @click.stop="switchTab(6)"
                  >
                    {{ $t('CargoMsg.Cargo_PendingDepartmentApproval') }}
                  </div>

                  <div
                    v-if="$checkPermission(['tab_ACPayAuth_fbFinanceVerify'])"
                    :class="['flat-tab-item', { active: applicationStatus === 2 }]"
                    @click.stop="switchTab(2)"
                  >
                    {{ $t('Payment.awaitFinancialApproval') }}
                  </div>

                  <div
                    v-if="$checkPermission(['tab_ACPayAuth_fbSupervisorVerify']) && billPaymentSetting.supervisorApproval"
                    :class="['flat-tab-item', { active: applicationStatus === 11 }]"
                    @click.stop="switchTab(11)"
                  >
                    {{ $t('CargoMsg.Cargo_PendingSupervisorApproval') }}
                  </div>

                  <div
                    v-if="$checkPermission(['tab_ACPayAuth_fbConfirm'])"
                    :class="['flat-tab-item', { active: applicationStatus === 3 }]"
                    @click.stop="switchTab(3)"
                  >
                    {{ $t('Payment.approval') }}
                  </div>

                  <div
                    v-if="$checkPermission(['tab_ACPayAuth_fbUnverify'])"
                    :class="['flat-tab-item', { active: applicationStatus === 4 }]"
                    @click.stop="switchTab(4)"
                  >
                    {{ $t('Payment.unpaid') }}
                  </div>
                  <div
                    v-if="!$checkPermission(['tab_ACPayAuth_fbAll']) &&
                      !$checkPermission(['tab_ACPayAuth_fbWait']) &&
                      !$checkPermission(['tab_ACPayAuth_fbApproval']) &&
                      !billPaymentSetting.departmentApproval &&
                      !$checkPermission(['tab_ACPayAuth_fbFinanceVerify']) &&
                      (!$checkPermission(['tab_ACPayAuth_fbSupervisorVerify']) || !billPaymentSetting.supervisorApproval) &&
                      !$checkPermission(['tab_ACPayAuth_fbConfirm']) &&
                      !$checkPermission(['tab_ACPayAuth_fbUnverify'])"
                    :class="['flat-tab-item', { active: applicationStatus === 5 }]"
                    @click.stop="switchTab(0)"
                  >
                    {{ $t('CargoMsg.Cargo_PaymentRequest') }}
                  </div>
                </template>
              </div>
            </div>
          </template>

          <bill-payment-list
            ref="billPaymentList"
            :is-append-query="true"
            :show-wht="true"
            view-source="basic"
            :bill-payment-setting="billPaymentSetting"
            :application-status="applicationStatus"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import billPaymentList from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentList'
import { getBranchBillPaymentSetting } from '@/api/sysManage/uiCustom'
import UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import Store from '@/store'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'BillPayment',
  components: { billPaymentList },
  data() {
    return {
      initialized: false,
      uiCustomEnable: false,
      showDeptApprovalTab: false,
      showSupervisorApprovalTab: false,
      billPaymentSetting: {},
      applicationStatus: 0,
      activeTabName: 'billPaymentList' // 固定为 billPaymentList
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const billPaymentSetting = await getBranchBillPaymentSetting({
        pageType: UICustomConstants.BILLPAYMENT_NATIVE_MODULE,
        branchId: Store.getters.currentOfficeId
      })
      next(vm => {
        vm.setInitialData(billPaymentSetting.data)
      })
    } catch (error) {
      console.error('路由进入时加载失败:', error)
      next(false)
    }
  },
  async beforeRouteUpdate(to, from, next) {
    try {
      await this.loadInitialData()
      next()
    } catch (error) {
      console.error('路由更新时加载失败:', error)
      next(false)
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      async handler() {
        await this.loadInitialData()
      }
    }
  },
  async created() {
    if (!this.initialized) {
      await this.loadInitialData()
      this.applicationStatus = this.uiCustomEnable ? 5 : 0
    }
  },
  methods: {
    setInitialData(billPaymentSettingData) {
      this.billPaymentSetting = billPaymentSettingData
      this.uiCustomEnable = billPaymentSettingData.openUiCustom
      this.initialized = true
    },

    async loadInitialData() {
      try {
        this.initialized = false
        this.loading = getLoading()
        await getBranchBillPaymentSetting({
          pageType: UICustomConstants.BILLPAYMENT_NATIVE_MODULE,
          branchId: this.$store.getters.currentOfficeId
        }).then(res => {
          if (res.data) {
            this.setInitialData(res.data)
          }
        }).finally(() => {
          this.loading.close()
        })
      } catch (error) {
        console.error('加载数据失败:', error)
        this.initialized = true
      }
    },

    switchTab(status) {
      this.applicationStatus = status
      // 触发子组件重新加载数据
      if (this.$refs.billPaymentList) {
        this.$refs.billPaymentList.applicationStatusChange()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-container {
  padding: 20px;
  background: white;
  min-height: 400px;
}

.tabs-container {
  min-height: 500px;
}

/* 平铺页签容器 */
.flat-tabs-container {
  display: flex;
  align-items: center;
  height: 29px;
  background: #FFF;
  border-bottom: 1px solid #E4E7ED;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin: -7px -7px 0 -7px;

  &::-webkit-scrollbar {
    display: none;
  }
}

.app-main-content .el-tabs--card .el-tabs__header .el-tabs__item {
  padding: 0 !important;
}

/* 平铺页签项 */
.flat-tab-item {
  padding: 0 10px;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: #606266;
  cursor: pointer;
  position: relative;
  transition: all 0.2s;
  border: none;
  background: transparent;
  font-weight: normal;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: max-content;
  //margin-right: 4px;
  border-radius: 4px;

  /* 添加竖形分割线 */
  &:not(:last-child)::after {
    content: '';
    position: absolute;
    right: -4px;
    top: 8px;
    height: 16px;
    width: 1px;
    background: #E4E7ED;
  }

  /* 悬停效果 */
  //&:hover {
  //  color: #409EFF;
  //  background: #f0f7ff;
  //}

  /* 激活状态 */
  &.active {
    color: #FFF;
    font-weight: 500;
    background: #3B74CE;
    border: 1px solid #3B74CE;

    /* 激活状态的底部蓝色线条 */
    &::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: -1px;
      height: 2px;
      background: #3B74CE;
      z-index: 2;
    }

    /* 激活状态下隐藏分割线 */
    &::after {
      display: none;
    }
  }

  /* 非激活状态的样式 */
  &:not(.active) {
    color: #606266;

    //&:hover {
    //  color: #409EFF;
    //  background: #f0f7ff;
    //}
  }
}

/* 确保页签样式与原始一致 */
:deep(.el-tabs__header) {
  margin: 0;
}

:deep(.el-tabs__item) {
  height: 40px;
  line-height: 40px;
  padding: 0 !important;
}

/* 隐藏 Element UI 的默认激活条和边框 */
:deep(.el-tabs__active-bar) {
  display: none !important;
}

:deep(.el-tabs--card > .el-tabs__header .el-tabs__item) {
  border: none !important;
}

:deep(.el-tabs--card > .el-tabs__header .el-tabs__nav) {
  border: none !important;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .flat-tab-item {
    padding: 0 16px;
    font-size: 13px;
  }
}

@media (max-width: 992px) {
  .flat-tab-item {
    padding: 0 14px;
    font-size: 12px;
  }

  .flat-tab-item {
    height: 30px;
    line-height: 30px;
  }
}

@media (max-width: 768px) {
  .flat-tabs-container {
    padding: 0 8px;
  }

  .flat-tab-item {
    padding: 0 12px;
    font-size: 12px;
  }
}

/* 小屏幕下的页签换行处理 */
@media (max-width: 576px) {
  .flat-tabs-container {
    flex-wrap: wrap;
    height: auto;
    padding: 8px;
    border-bottom: none;
  }

  .flat-tab-item {
    margin: 2px;
    flex: 1;
    text-align: center;
    min-width: 80px;
    border: 1px solid #E4E7ED;
    border-radius: 4px;
    background: #F5F7FA;

    /* 移除分割线 */
    &::after {
      display: none;
    }

    /* 小屏幕下的激活状态 */
    &.active {
      background: #409EFF;
      color: #FFF;
      border-color: #409EFF;

      &::before {
        display: none;
      }
    }

    /* 移除小屏幕下的底部线条 */
    &::before {
      display: none;
    }
  }
}
</style>
